<div class="frame">
    <div #container class="container">
        <div class="inner">
            <div [hidden]="showPrivateServer === false">
                <label class="head">Digital Signage network</label>
                <hr/>
                <mat-radio-group #hostType [disabled]="blockUI" aria-label="Select an option">
                    <mat-radio-button [checked]="true" style="display: block" value="1">cloud</mat-radio-button>
                    <mat-radio-button style="display: block" value="2">private server</mat-radio-button>
                </mat-radio-group>
                <input type="text" matInput #domain [disabled]="blockUI" class="item2">
                <br/>
                <button mat-stroked-button #connect [disabled]="blockUI" class="buttonStart" type="button"
                        (click)="onClick()">
                    connect
                </button>
            </div>

        </div>

    </div>
</div>

